export default __webpack_public_path__ + "static/media/asset_artifact_complete.2598d326.svg";